import { api } from "./api";


export const dashboardData = async () => {
  return await api.get("/dashboard/view",);
};


export const absentPresentData = async (addUrl = '') =>{
  let url = `/present/absent/data?${addUrl}`
  return api.get(url)
}

export const SendMessagePresent = async (addUrl)=>{
  let url = `/present/student/attendance/send/message?${addUrl}`
  return api.get(url)
}
export const SendMessageAbsent = async (addUrl)=>{
  let url = `attendance/send/absent/message?${addUrl}`
  return api.get(url)
}
export const AllAbsentAuto = async (data)=>{
  return api.get(`attendance/auto/absent`,data)
}

export const issueSubmit = async (data) =>{
  return api.post(`help/support/add`,data)
}
export const issueErrorList = async (data) =>{
  return api.get(`help/support/list`,data)
}